// ANB_perf-init.js — lightweight script sequencer for performance
(function () {
  function boot(src) {
    var s = document.createElement('script');
    s.src = src;
    s.defer = true;
    document.head.appendChild(s);
  }

  // Helper: environment checks
  var isMobile = matchMedia && matchMedia('(pointer: coarse)').matches;

  // 1) Idle-load: analytics/heatmaps/etc.
  (window.requestIdleCallback || function (cb) { setTimeout(cb, 1); })(function () {
    document.querySelectorAll('script[data-idle-src]').forEach(function (el) {
      var src = el.getAttribute('data-idle-src');
      // Optional desktop/mobile gating
      var desktopOnly = el.hasAttribute('data-desktop-only');
      var mobileOnly  = el.hasAttribute('data-mobile-only');
      if (desktopOnly && isMobile) return;
      if (mobileOnly && !isMobile) return;
      if (src) boot(src);
    });
  });

  // 2) First-interaction: popups, marketing widgets, link preloader, chat
  var kicked = false;
  function onFirstInteraction() {
    if (kicked) return; kicked = true;
    document.querySelectorAll('script[data-lazy-src]').forEach(function (el) {
      var src = el.getAttribute('data-lazy-src');
      var desktopOnly = el.hasAttribute('data-desktop-only');
      var mobileOnly  = el.hasAttribute('data-mobile-only');
      if (desktopOnly && isMobile) return;
      if (mobileOnly && !isMobile) return;
      if (src) boot(src);
    });
  }
  addEventListener('pointerdown', onFirstInteraction, { once: true });
  addEventListener('keydown',      onFirstInteraction, { once: true });

})();
